import { useContext } from 'react';
import { NotificationsContext } from '@context/notifications_context';

export const useNotificationsContext = () => {
    return useContext(NotificationsContext);
};
